import exportStatus from '../../../MovimentacaoCadastral/MovimentacoesPorArquivo/ConsultarEnvios/options';

const { statusDetail } = exportStatus;

export default async function filterData(data = [], movementType) {
    if (!data) {
        data = [];
    }

    const shape =
        movementType === 'Movimentações pendentes'
            ? [
                  {
                      id: 'Movimentações em rascunho',
                      statusValue: 2,
                      value: 0,
                      color: '#0B7EB5',
                  },
                  {
                      id: 'Movimentações em análise',
                      statusValue: 3,
                      value: 0,
                      color: '#5B5B5F',
                  },
                  {
                      id: 'Movimentações recusadas',
                      statusValue: 4,
                      value: 0,
                      color: '#EC130F',
                  },
                  {
                      id: 'Movimentações em autorização',
                      statusValue: 5,
                      value: 0,
                      color: '#EC130F',
                  },
                  {
                      id: 'Movimentações enviadas',
                      statusValue: 6,
                      value: 0,
                      color: '#0bb537',
                  },
                  {
                      id: 'Movimentações pedentes de ajuste',
                      statusValue: 7,
                      value: 0,
                      color: '#EC130F',
                  },
              ]
            : [
                  {
                      id: 'Arquivos enviados',
                      statusGroup: 2,
                      value: 0,
                      color: '#5B5B5F',
                  },
                  {
                      id: 'Arquivos processados',
                      statusGroup: 1,
                      value: 0,
                      color: '#0B7EB5',
                  },
                  {
                      id: 'Arquivos recusados',
                      statusGroup: 3,
                      value: 0,
                      color: '#EC130F',
                  },
              ];

    let filteredData = [];

    if (movementType === 'Movimentações pendentes') {
        filteredData = data.reduce((acc, cur) => {
            if (
                cur.status === 2 ||
                cur.status === 3 ||
                cur.status === 4 ||
                cur.status === 5 ||
                cur.status === 6 ||
                cur.status === 7
            ) {
                shape[cur.status - 2].value = acc[cur.status - 2].value + 1;
            }

            return shape;
        }, shape);

        return filteredData;
    }

    filteredData = data.reduce((acc, cur) => {
        const index = statusDetail[cur.statusCodigoSituacao].grupo;

        shape[index - 1].value = acc[index - 1].value + 1;

        return shape;
    }, shape);

    return filteredData;
}
